import { useQuery } from '@tanstack/react-query';
import { getAutomations } from '@/services/dmAutomation.service';
import { queryKeys } from '@/hooks/queries/keys';

export const useAutomations = (options?: { enabled?: boolean }) => {
    return useQuery({
        queryKey: queryKeys.dmAutomation.list(),
        queryFn: getAutomations,
        enabled: options?.enabled ?? true,
    });
};
